/* eslint-disable @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-unsafe-assignment */
import { BUTTON_SIZES } from '@elliemae/ds-button-v2';
import { CloseMedium } from '@elliemae/ds-icons';
import { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../ControlledDateTimePickerCTX.js';
import { StyledClearButton } from '../Styleds.js';
import { useClearButton } from './useClearButton.js';

export const ClearButton = (): JSX.Element => {
  const { onClearClick, onClearButtonKeyDown, clearButtonRef, withClearBtn } = useClearButton();
  const styledsAttrs = {
    shouldDisplay: withClearBtn,
  };
  const {
    latestInteractionRegion,
    currFocusDescriber,
    getProps,
    props: { tabIndex },
  } = useContext(ControlledDateTimePickerContext);

  return (
    <StyledClearButton
      aria-label="clear selected date"
      buttonType="icon"
      size={BUTTON_SIZES.M}
      data-testid={ControlledDateTimePickerDatatestid.CLEAR_BUTTON}
      innerRef={(DomElem: HTMLButtonElement) => {
        clearButtonRef.current = DomElem;
        if (latestInteractionRegion === 'clear-btn' && currFocusDescriber === 'clear-btn') DomElem?.focus?.();
      }}
      tabIndex={tabIndex}
      onClick={onClearClick}
      onKeyDown={onClearButtonKeyDown}
      type="button"
      getOwnerProps={getProps}
      {...styledsAttrs}
    >
      <CloseMedium color={['brand-primary', '600']} />
    </StyledClearButton>
  );
};
